import { createCarritoSlice } from '../createCarritoSlice';

export const carritoSlice = createCarritoSlice('carrito');

// Action creators are generated for each case reducer function
export const {
  agregarDatos,
  agregarProducto,
  quitarProducto,
  vaciarCarrito,
  reemplazarCarrito,
} = carritoSlice.actions;

export default carritoSlice.reducer;
